import type { GroupStatsResponse, StatsPeriod } from "@qota/shared";
import { request } from "./http";

export function getStats(
  groupId: string,
  period: StatsPeriod,
  month?: string | null,
): Promise<GroupStatsResponse> {
  const query = new URLSearchParams({ period });
  if (month) query.set("month", month);

  return request<GroupStatsResponse>("GET", `/groups/${groupId}/stats?${query.toString()}`);
}
